export default __webpack_public_path__ + "static/media/Guestbook.b93b314e.PNG";